/**
 * Status enum for device pairing flow
 */
export enum DevicePairingStatus {
  INTRO = 'intro',
  IDLE = 'idle',
  STARTING = 'starting',
  ACTIVE = 'active',
  SUCCESS = 'success',
  EXPIRED = 'expired',
  ERROR = 'error',
}
